module.exports = __webpack_public_path__ + "images/cart-background-5c1c3f81e54b59f55acc3191bc58a530.jpg";